import { render } from "./CreateTaskType.vue?vue&type=template&id=4ed9074f"
import script from "./CreateTaskType.vue?vue&type=script&lang=js"
export * from "./CreateTaskType.vue?vue&type=script&lang=js"

import "./CreateTaskType.vue?vue&type=style&index=0&id=4ed9074f&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__